module.exports = {
  scriptSource: 'https://cdn.printos.com/printos-partner-header/${version}/header.js',
  defaults: {
    varName: 'printos.domain'
},
  rules: [{
    id: 'dev',
    match: ['daily.gsbprint.net', 'localhost'],
    version: "0.1.8"
}, {
    id: 'qual',
    match: ['qual.printopt.org', 'pressqa.printopt.org'],
    version: '0.1.3'
}, {
    id: 'migration',
    match: 'migration.printopt.org',
    version: '0.1.3'
}, {
    id: 'pressqanext',
    match: 'pressqanext.printopt.org',
    version: '0.1.3'
}, {
    id: 'next-staging',
    match: 'stg.printopt.org',
    version: '0.1.3'
}, {
    id: 'production',
    default: true,
    match: 'printos.com',
    version: '0.1.3'
}],
};



//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 1
// module chunks = 0